import React, { FC, HTMLAttributes, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { getGravatarURL, GravatarOptions } from './Utils';

const AvatarContainer = styled.img<{ $size: number }>`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  border-radius: 50%;
  object-fit: cover;
`;

export type AvatarProps = HTMLAttributes<HTMLImageElement> & {
  email: string | undefined;
  name: string;
  size?: number;
  className?: string;
  fallback?: GravatarOptions['fallback'];
};

export const Avatar: FC<AvatarProps> = ({ email, size = 96, name, className, fallback, ...imgProps }) => {
  const [avatarUrl, setAvatarUrl] = useState<string>('');
  const loadAvatar = useCallback(async () => {
    if (email) {
      try {
        const url = await getGravatarURL(email, { size, fallback, name });

        setAvatarUrl(url);
      } catch (error) {
        // Ignore.
      }
    }
  }, [email, size, fallback, name]);

  useEffect(() => {
    void loadAvatar();
  }, [loadAvatar]);

  return avatarUrl ? (
    <AvatarContainer {...imgProps} src={avatarUrl} alt={name || email} $size={size} className={className} />
  ) : undefined;
};
